import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'adc-header',
  templateUrl: './adc-header.component.html',
  styleUrls: ['./adc-header.component.scss'],
  standalone: false
})
export class AdcHeaderComponent implements OnChanges{
  @ViewChild("dropdown1") dropdownRef1: ElementRef | undefined;
  @ViewChild("dropdown2") dropdownRef2: ElementRef | undefined;
  @HostListener("document:click", ["$event"])
  onClick(event: Event) {
    if (
      this.dropdownRef1 &&
      !this.dropdownRef1.nativeElement.contains(event.target)
    ) {
      this.showDropdown = false;
    }
    // if (
    //   this.dropdownRef2 &&
    //   !this.dropdownRef2.nativeElement.contains(event.target)
    // ) {
    //   this.showRightDropdown = false;
    // }
  }
  @Input('type') type: any;
  @Input('data') data: any;
  @Output() toggle !: EventEmitter<boolean>;
  @Output() langObj = new EventEmitter<any>();
  @Output('theme') theme = new EventEmitter<any>();
  @Output('logout') logout = new EventEmitter<any>();
  @Output('fontchanges') fontValueChanges = new EventEmitter<any>();
  @Input('sidebarToggle') sidebarToggle!: boolean;
  @Input() showToggle!: boolean;
  showDropdown: boolean = false;
  langDropdown: boolean = false;
  moreItems: string[] = ['Dashboard', 'Maintenance', 'About', 'Contact'];
  menuItems: string[] = ['Dashboard', 'Maintenance', 'About', 'Contact', 'Settings', 'Notification', 'Profile'];
  showRightDropdown: boolean = false;
  activeRightDropdownIndex: number | null = null;
  currentLanguage!: string;


  constructor() {
    this.toggle = new EventEmitter<boolean>();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.sidebarToggle = changes['sidebarToggle'].currentValue;
    
    if(changes && changes['sidebarToggle'].currentValue) {
      this.sidebarToggle = changes['sidebarToggle'].currentValue;
    }
  }

  ngOnInit(): void {
    this.currentLanguage = 'en';
  }

  closeDropdown() {
    this.showRightDropdown = false;
  }

  dropdown(event: any) {
    // this.showDropdown = !this.showDropdown;
    const dropdownContent = document.querySelector('.adc-dropdown-option-menu');

    if (dropdownContent && !dropdownContent.contains(event.target as Node)) {
      this.showDropdown = false;
    } else {
      this.showDropdown = !this.showDropdown;
    }
  }

  toggleAction() {
    this.sidebarToggle =! this.sidebarToggle;
    this.showToggle = this.sidebarToggle;
    this.toggle.emit(this.showToggle)
  }
  
  toggleLangDropdown() {
    this.langDropdown = !this.langDropdown;
  }

  toggleLang(i: any) {
    this.currentLanguage = i.itemCode;
    this.langObj.emit(i);
  }

  fontsizeChanges(action: any) {
    this.fontValueChanges.emit(action);
  }

  onDropdownClick(event: MouseEvent) {
    event.stopPropagation(); // Ensure clicks within the dropdown do not propagate to the document
  }

  toggleRightDropdown(index: number, event: any): void {
    event.stopPropagation();
    if (this.activeRightDropdownIndex === index) {
      // Clicking the same dropdown again, toggle its open/close state
      this.showRightDropdown = !this.showRightDropdown;
    } else {
      // Clicking a different dropdown, close the previous one and open the new one
      this.showRightDropdown = true;
    }
    this.activeRightDropdownIndex = index;
  }

  actionRight(name: any, child: any) {
    this.showRightDropdown = false;
    if(name === 'palette') {
      this.theme.emit(child);
    }else if(name === 'person') {
      this.logout.emit(child);
    }
  }

}
